<template>
  <div class="reg_box">
    <div class="reg_title">充值大唐币</div>
    <div class="reg_row"><span class="reg_left">充值账号：</span><span>{{userData.userId}}</span></div>
    <div class="reg_row"><span class="reg_left">GID：</span><span>{{userData.gid}}</span></div>
    <div class="reg_row"><span class="reg_left">游戏名称：</span><span >大唐平台</span></div>
    <div class="reg_row"><span class="reg_left">请选择充值金额：</span>
      <span class="charges">
        <span :class="['charge_num',item==selectNum?'active':'']" @click="changeCharge(item)" v-for="item in chargeNum">{{item}}元</span>
      </span>
    </div>
    <div class="reg_row"><span class="reg_left">获得数量：</span><span class="diamond">{{selectNum*10}}</span><span class="diamond_font">大唐币</span></div>
    <div class="reg_row tip">
      <span class="reg_left"></span>
      <div class="tip_content">
        <span >1元人民币=10大唐币（1:10）=10游戏币</span><span >游戏币只能用户购买游戏中的相关道具不可用于其他用途 官方保证使用合法的渠道为用户充值</span><span >我们将尽最快的速度为用户完成充值，如果您充值后，20 分钟大唐币未到账，请与客服人员联系，我们将第一时间处 理您的充值问题</span>
      </div>
    </div>
    <div class="reg_row"><span class="reg_left">支付方式：</span><span class="pay_method"><img src="../../images/zhifubao.png" alt="">支付宝</span></div>
    <div class="reg_row"><span class="reg_left"></span><span class="reg_action" @click="toPay">立即充值</span><span class="cancel_action" @click="changePage({name:'home'})">取消</span></div>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { mapState } from 'vuex'
  export default {
    data() {
      return {
        agree:false,
        appSecret : "b43f0148b81511957b28e011584ea4c73570f700784cdf7891f1c040a353baca",
        clientType:3,
        chargeNum:[1,10,100,500,1000],
        selectNum:1,
        orderInfo:null
      }
    },
    methods: {
      ...mapMutations([
        'setPage','logout'
      ]),
      changeAgree(){
        this.agree = !this.agree;
      },
      changeCharge(data){
        this.selectNum = data;
      },
      //nonce生成*位随机串
      getNonce(len, charSet){
        charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
          var randomPoz = Math.floor(Math.random() * charSet.length);
          randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
      },
      sign(method,appId,nonce,timestamp,signUrl,appSec){
        var str = method + 'X-QP-AppId:'+appId+'X-QP-Nonce:'+nonce+'X-QP-Timestamp:'+timestamp+signUrl+appSec;
        var newStr = hex_md5(str).toUpperCase();
        return newStr;
      },
      getOS(){
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          return 'ios';
        } else if (/(Android)/i.test(navigator.userAgent)) {
          return 'android';
        }
      },
      changePage(path){
        this.$router.push(path);
      },
      toPay(wPar1){
        var wurl = this.gameInfo.mallUrl+'/co/v1/pay/buyProd';
        var wtimestamp = new Date().getTime().toString().substring(0,10);
        var wnonce = new Date().getTime().toString() + this.getNonce(19);
        var wdata = {
          gId: this.userData.gid,
          payPrice:this.selectNum,
          clientType: this.clientType,
          appKey: this.$ajaxUrls.appKey,
          prodType: 3,
          payChannel:1
        };
        this.$axios({
          url: wurl,
          method: 'post',
          data:wdata,
          headers:{
            'X-QP-AppId': 200010,
            'X-QP-AppVersion': '1.0.1',
            'X-QP-ResVersion': '1.0.1',
            'X-QP-OS': this.getOS(),
            'X-QP-OSVersion': '',
            'X-QP-ClientType': this.clientType,
            'X-QP-UserId': this.userData.userId,
            'X-QP-Gid': this.userData.gid,
            'X-QP-Timestamp': wtimestamp,
            'X-QP-Nonce': wnonce,
            'X-QP-Signature': this.sign('POST',200010,wnonce,wtimestamp,wurl,this.appSecret),
            'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.orderInfo = res.data.data;
            this.payConfirm();
            window.open(res.data.data.truePayUrl);
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      getGameInfo(){//获取游戏信息
        let appKey = this.$ajaxUrls.appKey;
        if(!appKey){
          appKey = this.$ajaxUrls.gamesKey.chuanqi;
        }
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.ganmeInfo + '?appKey='+appKey;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':200010,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',200010,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            this.gameInfo = res.data.data;
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      open(msg='请求失败',callback) {
        this.$alert(msg, '提示', {
          confirmButtonText: '确定',
          callback: action => {
            if(callback){
              if(!!this.$ajaxUrls.appKey){
                callback()
              }
            }
          }
        });
      },
      payConfirm(msg='确认支付',callback) {
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal:false,
          closeOnPressEscape:false,
          type: 'warning'
        }).then(() => {
          this.getStatus();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      getStatus(){
        var gurl = this.gameInfo.mallUrl+'/co/v1/orders/orderInfo?orderNo='+this.orderInfo.orderNo;
        var gtimestamp = new Date().getTime().toString().substring(0,10);
        var gnonce = new Date().getTime().toString() + this.getNonce(19);
        this.$axios({
          url: gurl,
          method: 'get',
          headers:{
            'X-QP-AppId': 200010,
            'X-QP-AppVersion': '1.0.1',
            'X-QP-ResVersion': '1.0.1',
            'X-QP-OS': this.getOS(),
            'X-QP-OSVersion': '',
            'X-QP-ClientType': this.clientType,
            'X-QP-UserId': this.userData.userId,
            'X-QP-Gid': this.userData.gid,
            'X-QP-Timestamp': gtimestamp,
            'X-QP-Nonce': gnonce,
            'X-QP-Signature': this.sign('GET',200010,gnonce,gtimestamp,gurl,this.appSecret),
            'X-QP-Token': this.userData.accessToken,
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            if(res.data.data.orderState == 1){  //支付成功
              this.getAsset();
              //this.open("支付成功！",this.changePage.bind(null,{path: '/home'}));
            }else if(res.data.data.orderState == 0){  //未支付
              this.open("未支付！");
            }else if (res.data.data.orderState == 2) {  //支付失败
              this.open("支付未成功，如有疑问请联系客服！");
            }
          }else if(res.errCode == 80003){
            this.logout();
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      },
      success(number){
        const h = this.$createElement;
        this.$msgbox({
          title: '充值成功',
          message: h('p', null, [
            h('span', null, '充值成功，当前大唐币余额 '),
            h('span', { style: 'color: red' }, number)
          ]),
          showCancelButton: true,
          confirmButtonText: '继续充值',
          cancelButtonText: '返回首页'
        }).then(action => {
        }).catch(() => {
          this.changePage({path: '/home'})
        });
      },
      getAsset(){
        let ltimestamp = new Date().getTime().toString().substring(0,10);
        let lnonce = new Date().getTime().toString() + this.getNonce(19);
        let url = this.$ajaxUrls.ams + this.userData.gid;
        this.$axios({
          url: url,
          method: 'get',
          headers:{
            'X-QP-AppId':200010,
            'X-QP-AppVersion':'1.0.1',
            'X-QP-ResVersion':'1.0.1',
            'X-QP-OS':this.getOS(),
            'X-QP-OSVersion':'',
            'X-QP-ClientType':this.clientType,
            'X-QP-Timestamp': ltimestamp,
            'X-QP-Nonce': lnonce,
            'X-QP-Signature':this.sign('GET',200010,lnonce,ltimestamp,url,this.appSecret)
          }
        }).then((res)=>{
          if(res.data.errCode === 0){
            res.data.data.forEach( (e)=> {
              if(e.assetId ==1002){
                this.success(e.assetCount)
              }
            });
          }else{
            this.open(res.data.errDesc)
          }
        }).catch((err)=>{
          alert(err)
        })
      }
    },
    mounted() {
      if(!this.userData.gid){
        this.open("请先登录");
        this.$router.push({name:"home"});
        return false
      }
      this.getGameInfo();
    },
    computed: mapState([
      'loginPage','userData'
    ])
  }
</script>

<style lang="scss" scoped>
  @import '../../components/style/mixin';
  .reg_box{width: 1340px;margin: 0 auto;padding-top: 25px;background: url("../../images/reg_g.png") no-repeat;background-size: 100% 100%;height: 830px}
  .reg_title{color: #333333;font-size: 24px;text-align: center;margin-bottom: 25px;padding-top: 40px}
  .reg_left{display: inline-block;width: 120px;text-align: right;font-size: 14px;margin-right: 35px;vertical-align: top}
  .agreement{font-size: 12px;margin-bottom: 20px;padding-left: 450px;margin-top: 30px}
  .check{display: inline-block;width: 18px;height: 18px;border-radius: 5px;border: 1px solid #ccd5db;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .checked{display: inline-block;width: 16px;height: 16px;border-radius: 5px;border: 1px solid #ccd5db;color: #1990FF;font-weight: bold;cursor: pointer;vertical-align: text-bottom;margin-right: 5px}
  .to_agree{cursor: pointer;color: #1990FF}
  .reg_row{padding-left: 450px;line-height: 42px;margin-bottom: 15px}
  .tips{color: #A2A2A2;font-size: 13px}
  input{height: 42px;width:260px;font-size: 14px;background-color: rgb(247,247,247);border-radius: 5px;padding-left: 10px}
  input::-webkit-input-placeholder { color: #999;}
  input::-moz-placeholder{ color: #999;}
  input:-ms-input-placeholder{ color: #999;}
  .getCode{width: 96px;height: 42px;line-height: 42px;color: #ffffff;background-color: #1990FF;border-radius: 5px;font-size: 14px;display: inline-block;text-align: center;cursor: pointer}
  .reg_action{width:260px;  height:50px;  background:rgba(25,144,255,1);  border-radius:25px;display: inline-block;text-align: center;cursor: pointer;color: #ffffff;line-height: 50px}
  .cancel_action{width:96px;  height:50px;  background:rgba(255,255,255,1);  border-radius:25px;  border:1px solid rgba(204,213,219,1);text-align: center;cursor: pointer;line-height: 50px;display: inline-block;margin-left: 40px}
  .charges{width: 400px;display: inline-block}
  .charges .active{ background:rgba(25,144,255,1);color: #ffffff}
  .charge_num{width:96px;  height:42px; background-color: rgb(247,247,247);  border-radius:4px;display: inline-block;text-align: center;color: #666666;font-size: 14px;margin-right: 20px;cursor: pointer;margin-bottom: 20px}
  .diamond{color: #F35D63;font-size: 24px;margin-right: 15px;font-weight: bold}
  .diamond_font{font-size: 14px;font-weight: bold;color: #333333}
  .tip{display: flex;font-size: 13px;color: #A2A2A2;line-height: 18px;}
  .tip .reg_left{flex: 0 0 120px}
  .tip_content{display: flex;flex-direction: column;width: 500px;margin-bottom: 10px}
  .pay_method{width:96px;  height:42px;  background:rgba(216,216,216,0.2);  border-radius:4px;  border:1px solid rgba(25,144,255,1);display: inline-block;padding-left: 10px;cursor: pointer}
  .pay_method img{width: 24px;height: 24px;vertical-align: text-bottom;margin-right: 5px}
</style>
